module.exports = "/kiosk/kiosk-location-picker-e46903.html";